import { didCounterIncrease } from '@/common/utils/documentTitleBlink'
import { defineStore } from 'pinia'
import { ref } from 'vue'

interface CounterData {
  counts: number[]
  timestamp: number
}

function normalizeCountValue(countValue: unknown): number[] | undefined {
  if (countValue === undefined || countValue === null) return undefined
  if (Array.isArray(countValue)) {
    return countValue.map((v) => Number(v) || 0)
  }
  return [Number(countValue) || 0]
}

export const useMenuCountersStore = defineStore('menuCounters', () => {
  const counters = ref<Record<string, CounterData>>({})

  /**
   * @returns itemIds whose primary counter increased (candidates for window blink).
   */
  const updateCounters = (data: any): string[] => {
    const increasedIds: string[] = []
    if (!data?.rows) return increasedIds

    data.rows.forEach((row: any) => {
      const fields = row.fields
      if (!fields) return

      const itemId = fields._itemId?.value
      const counts = normalizeCountValue(fields._count?.value)
      const timestamp = fields._timestamp?.value || Date.now()

      if (itemId === undefined || counts === undefined) return

      const key = String(itemId)
      const existing = counters.value[key]

      if (!existing || timestamp > existing.timestamp) {
        if (didCounterIncrease(existing?.counts, counts)) {
          increasedIds.push(key)
        }
        counters.value[key] = { counts, timestamp }
      }
    })

    return increasedIds
  }

  const getCounters = (itemId: string | number): number[] | undefined => {
    return counters.value[String(itemId)]?.counts
  }

  const getCounter = (itemId: string | number): number | undefined => {
    return getCounters(itemId)?.[0]
  }

  const clear = () => {
    counters.value = {}
  }

  return { counters, updateCounters, getCounters, getCounter, clear }
})
